module.exports = "/static/assets/ea9b026bd998599c1f57d442c8a0cf52.svg";